import { Button } from '@carbon/react';
import { Add } from '@carbon/react/icons';
import style from './eval-left-panel.module.scss';

interface EvalLeftPanelHeaderProps {
  workspaceCount: number;
  evaluationCount: number;
  isAddDisabled: boolean;
  onAdd: () => void;
}

/**
 * Header section of the eval left panel. Displays the "Package Evaluation"
 * title, a create-workspace button, and summary counts.
 *
 * @param {EvalLeftPanelHeaderProps} props - Component props.
 * @return {JSX.Element} The left panel header.
 */
export const EvalLeftPanelHeader = ({
  workspaceCount,
  evaluationCount,
  isAddDisabled,
  onAdd,
}: EvalLeftPanelHeaderProps): JSX.Element => {
  return (
    <div className={style.headerSection}>
      <div className={style.headerTitleRow}>
        <h3 className={style.headerTitle}>Package Evaluation</h3>
        <Button
          kind="primary"
          size="sm"
          renderIcon={Add}
          hasIconOnly
          iconDescription="Create workspace"
          disabled={isAddDisabled}
          onClick={onAdd}
          className={style.addButton}
        />
      </div>
      <p className={style.summary}>
        {workspaceCount} Workspaces | {evaluationCount} Evaluations
      </p>
    </div>
  );
};
